import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api';

// 取得類別
export function getCate(data) {
    return get(`${url}/external/smsNotify/cate?key=${data}`, { ...options });
}

// 0. 登入
export function postLoginNotify(data) {
    return post(`${url}/auth/mNotifyPromoLogin`, data, { ...options, closeAlert: true });
}
